import React from 'react';

export const CheckMarkV2Icon = ({ fill = '#069183' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="26"
      viewBox="0 0 28 26"
      fill="none"
    >
      <path
        d="M21.2709 6.96521H11.5768C9.4757 6.96521 7.76807 8.49647 7.76807 10.3805V19.0735C7.76807 20.9575 9.4757 22.4888 11.5768 22.4888H21.2709C23.372 22.4888 25.0797 20.9575 25.0797 19.0735V10.3805C25.0797 8.49647 23.372 6.96521 21.2709 6.96521ZM20.7193 12.4938L16.0142 18.0805C15.8357 18.2915 15.568 18.4224 15.276 18.4479C15.2476 18.4479 15.2151 18.4515 15.1867 18.4515C14.9231 18.4515 14.6716 18.3642 14.481 18.2005L12.2542 16.3383C11.8364 15.9855 11.812 15.3999 12.2014 15.0216C12.5949 14.647 13.252 14.6252 13.6697 14.9743L15.0569 16.1346L19.0685 11.3699C19.4132 10.9589 20.0622 10.8788 20.5246 11.188C20.983 11.4972 21.0722 12.0828 20.7274 12.4938H20.7193Z"
        fill={fill}
      />
      <path
        d="M5.41545 17.2076C4.90843 17.2076 4.46631 16.8766 4.38925 16.4147L2.96149 7.81271C2.65322 5.95046 4.09315 4.21188 6.16989 3.93546L15.7586 2.65516C17.5149 2.42238 19.1901 3.2844 19.8512 4.75383C20.0662 5.2303 19.8066 5.77224 19.2753 5.96501C18.7399 6.15779 18.1355 5.925 17.9246 5.44853C17.6244 4.78292 16.8578 4.39011 16.0628 4.49558L6.4741 5.77588C5.52902 5.90318 4.87598 6.69245 5.01795 7.53992L6.44165 16.1383C6.52683 16.6475 6.13338 17.1203 5.56958 17.1967C5.51685 17.204 5.46412 17.2076 5.41545 17.2076Z"
        fill={fill}
      />
    </svg>
  );
};
